import React from 'react';
import PropTypes from 'prop-types';
import ValidatedForm from '../../../components/molecules/ValidatedForm';

const EmployerName = ({
  validateOnRegister,
  whitelist,
  data,
  showErrors,
}) => (
  <ValidatedForm.Autocomplete
    data={data}
    placeholder={data.placeholder}
    type="text"
    validateOnRegister={validateOnRegister}
    whitelist={whitelist}
    showErrors={showErrors}
  />
);

EmployerName.propTypes = {
  validateOnRegister: PropTypes.bool,
  whitelist: PropTypes.bool,
  data: PropTypes.shape().isRequired,
  showErrors: PropTypes.bool,
};

EmployerName.defaultProps = {
  validateOnRegister: false,
  whitelist: false,
  showErrors: false,
};

export default EmployerName;
